<template>
    <div :key="reRenderKey">
        <div id="pixi-house" ref="pixiHouse" />
    </div>
</template>

<script>
// import {mapGetters, mapMutations, mapActions} from 'vuex';
// import * as types from '@/store/types';
import EventBus from '@/eventBus'
// import SomeComponent from '@/components/SomeComponent.vue'

// import moment from 'moment'
import axios from 'axios'
const _ = require('lodash')
import * as config from '@/store/config'

import * as PIXI from 'pixi.js'
const TextInput = require('pixi-text-input') //https://github.com/Mwni/PIXI.TextInput
const PIXISound = require('pixi-sound') //https://github.com/pixijs/pixi-sound

import * as TWEEN from '@tweenjs/tween.js';
const TweenManager = TWEEN.default

import LoaderManager from './managers/LoaderManager'
import Util from './managers/PIXIUtil'

import EventDispatcher from '@/game/scenes/components/EventDispatcher'

const DEBUG_CONST = {
    enableDebug: false,
    startPage: "p1",
}

const CONFIG_CONST = {
    shortDim: 960,
    longDim: 1280,
    backgroundColor: "0xffc73a",
}

function onDragStart(event){
    // store a reference to the data
    // the reason for this is because of multitouch
    // we want to track the movement of this particular touch
    this.data = event.data
    this.alpha = 0.5
    this.dragging = true
}

function onDragEnd(){
    this.alpha = 1

    this.dragging = false

    // set the interaction data to null
    this.data = null

    console.log( this.textureName )
    // console.log( Math.round(this.position.x) )
    // console.log( Math.round(this.position.y) )

    // PORTRAIT
    console.log('PORTRAIT')
    console.log( this.position.x / CONFIG_CONST.shortDim )
    console.log( this.position.y / CONFIG_CONST.longDim )

    //LANDSCAPE
    console.log('LANDSCAPE')
    console.log( this.position.x / CONFIG_CONST.longDim )
    console.log( this.position.y / CONFIG_CONST.shortDim )
}

function onDragMove(){
    if (this.dragging)
    {
        var newPosition = this.data.getLocalPosition(this.parent)
        this.position.x = newPosition.x
        this.position.y = newPosition.y
    }
}

export default { 
    props: [
        // "items"
    ],
    data() {
        return {
            reRenderKey: 0,
            app: new PIXI.Application({
                width: CONFIG_CONST.shortDim, 
                height: CONFIG_CONST.longDim,
            }),
            // app: new PIXI.Application({ resizeTo: window }),
            renderer: null,
            width: CONFIG_CONST.shortDim,
            height: CONFIG_CONST.longDim,
            ratio: CONFIG_CONST.shortDim / CONFIG_CONST.helongDimight,
            iter: 0,
            textureMap: null,
            audioPlayed: false,
            eventDispatcher: EventDispatcher.create(),
            checkmarks: [],
            gameState: {
                _currPage: "p1",
                _prevPage: "p1",
                _pages: {
                    p1: [],
                    p2: [],
                    p3: [],
                    p4: [],
                    p5: [],
                    p6: [],
                    p7: [],
                    p8: [],
                    p9: [],
                    p10: [],
                    p11: [],
                    p12: [],
                    p13: [],
                },
                _answers: {
                    p2: -1,
                    p3: -1,
                    p4: -1,
                    p5: -1,
                    p6: -1,
                    p7: -1,
                    p8: -1,
                    p9: -1,
                },
                setAnswer: function(pageKey, answer) {
                    this._answers[ pageKey ] = answer
                },
                getScore: function() {
                    let score = 0
                    _.keys( this._answers ).forEach( (key) => {
                        score += (this._answers[ key ])
                    })
                    return score
                },
                getResultPage: function() {
                    const score = this.getScore()

                    if( score >= 18 ) {
                        return 'p13'
                    } else if( score >= 14 ) {
                        return 'p12'
                    } else if( score >= 6 ) {
                        return 'p11'
                    } else {
                        return 'p10'
                    }
                },
                addChild: function(pageKey, elem) {
                    this._pages[ pageKey ].push(elem)
                },
                setPage: function(pageKey) {
                    const self = this
                    _
                        .chain(self._pages[ self._currPage ])
                        .forEach((elem) => {
                            elem.hide()
                        })
                        .value()

                    self._prevPage = self._currPage
                    self._currPage = pageKey

                    _
                        .chain(self._pages[ self._currPage ])
                        .forEach((elem) => {
                            elem.show()
                        })
                        .value()
                },
                getCurrPage: function() {
                    const self = this
                    return self._currPage
                },
                hideAllPages: function() {
                    const self = this
                    _.keys(self._pages).forEach( (key) => {
                        _
                            .chain(self._pages[ key ])
                            .forEach((elem) => {
                                elem.hide()
                            })
                            .value()
                    })
                },
            },
        };
    },
    mounted: function () {
        const self = this
        const app = self.app

        const bgm = PIXISound.default.sound.Sound.from( require( "@/game/assets/admiralbob77-Isolation-Swing-5_compressed.mp3" )  )
        bgm.play()
        
        // self.registerBGM( require( "@/game/assets/admiralbob77-Isolation-Swing-5_compressed.mp3" ) )

        this.$refs.pixiHouse.appendChild(app.view)

        self.renderer = app.renderer

        self.renderer.backgroundColor = CONFIG_CONST.backgroundColor

        window.addEventListener("resize", self.resize);
        self.resize()

        LoaderManager.load( PIXI, app, function(textureMap, resources) {
            self.textureMap = textureMap

            const addSprite = function(textureName, x, y, scale) {
                const sp = new PIXI.Sprite( textureMap[ textureName ].texture )
                sp.x = app.renderer.width * x
                sp.y = app.renderer.height * y
                sp.anchor.x = 0.5
                sp.anchor.y = 0.5
                sp.scale.set(scale)
                sp.textureName = textureName
                app.stage.addChild(sp)

                return sp
            }

            const makeDragable = function(elem) {
                elem.interactive = true
                elem.buttonMode = true
                elem
                    .on('mousedown', onDragStart)
                    .on('touchstart', onDragStart)
                    .on('mouseup', onDragEnd)
                    .on('mouseupoutside', onDragEnd)
                    .on('touchend', onDragEnd)
                    .on('touchendoutside', onDragEnd)
                    .on('mousemove', onDragMove)
                    .on('touchmove', onDragMove)                
            }

            const makeAnswer = function(elem, page, answer, finish) {
                //DEBUG
                if( DEBUG_CONST.enableDebug )
                    return
                //

                elem.interactive = true
                elem.buttonMode = true
                elem.on('pointerdown', function (event)
                {
                    // console.log(event.data.getLocalPosition(this.parent).y) 
                    
                    if(page == 'p5') {
                        if(answer == "NEXT") {                            
                            let score = 0
                            let count = 0
                            for(let i = 0; i < self.checkmarks.length; ++i) {
                                if( self.checkmarks[i].visible )
                                    ++count
                            }
                            if(count >= 4) {
                                score = 3
                            } else if(count >= 2) {
                                score = 2
                            } else if(count >= 1) {
                                score = 1
                            } else {
                                score = 0
                            }
                            let compensateScoreIndex = 0
                            self.gameState.setAnswer(page, score + compensateScoreIndex)
                        } else {
                            if(self.checkOrientation() == "PORTRAIT") {
                                if( event.data.getLocalPosition(this.parent).y < 433 ) 
                                    self.gameState.setAnswer(page, 0)                        
                                else if( event.data.getLocalPosition(this.parent).y < 580 ) 
                                {
                                    self.checkmarks[1].visible = !self.checkmarks[1].visible
                                    return
                                }
                                else if( event.data.getLocalPosition(this.parent).y < 725 ) 
                                {
                                    self.checkmarks[2].visible = !self.checkmarks[2].visible
                                    return
                                }
                                else if( event.data.getLocalPosition(this.parent).y < 860 ) 
                                {
                                    self.checkmarks[3].visible = !self.checkmarks[3].visible
                                    return
                                }
                                else if( event.data.getLocalPosition(this.parent).y < 985 ) 
                                {
                                    self.checkmarks[4].visible = !self.checkmarks[4].visible
                                    return
                                }
                                else
                                {
                                    self.checkmarks[5].visible = !self.checkmarks[5].visible
                                    return
                                }
                            } else {
                                if( event.data.getLocalPosition(this.parent).y < 197 ) 
                                    self.gameState.setAnswer(page, 0)                        
                                else if( event.data.getLocalPosition(this.parent).y < 343 ) 
                                {
                                    self.checkmarks[1].visible = !self.checkmarks[1].visible
                                    return
                                }
                                else if( event.data.getLocalPosition(this.parent).y < 484 ) 
                                {
                                    self.checkmarks[2].visible = !self.checkmarks[2].visible
                                    return
                                }
                                else if( event.data.getLocalPosition(this.parent).y < 615 ) 
                                {
                                    self.checkmarks[3].visible = !self.checkmarks[3].visible
                                    return
                                }
                                else if( event.data.getLocalPosition(this.parent).y < 745 ) 
                                {
                                    self.checkmarks[4].visible = !self.checkmarks[4].visible
                                    return
                                }
                                else
                                {
                                    self.checkmarks[5].visible = !self.checkmarks[5].visible
                                    return
                                }
                            }
                        }
                    } else {                    
                        self.gameState.setAnswer(page, answer)
                    }

                    const nextPage = 'p' + (parseInt( page.substring(1) ) + 1)
                    self.gameState.setPage( nextPage )
                    if(nextPage == 'p5') {
                        for(let i = 0; i < self.checkmarks.length; ++i) {
                            self.checkmarks[i].visible = false
                        }
                    }
                    if(finish != null) {
                        const score = self.gameState.getScore()
                        console.log(self.gameState._answers)
                        console.log(score)
                        self.gameState.setPage( 
                            self.gameState.getResultPage() 
                        )

                        let answerStr = ""
                            + self.gameState._answers.p2
                            + ","
                            + self.gameState._answers.p3
                            + ","
                            + self.gameState._answers.p4
                            + ","
                            + self.gameState._answers.p5
                            + ","
                            + self.gameState._answers.p6
                            + ","
                            + self.gameState._answers.p7
                            + ","
                            + self.gameState._answers.p8
                            + ","
                            + self.gameState._answers.p9

                        axios.post(
                            config.BASE_URL + "/veggiequiz", 
                            {
                                "answers" : answerStr,
                                "score" : parseInt(score),
                            },
                            config.JSON_HEADER_CONFIG
                        )
                        .then((res) => {
                            console.log(res.data)
                        })
                        .catch((err) => {
                            console.log("AXIOS ERROR: ", err)
                        })
                    }
                })
            }

            const addDefaultShowHide = function(elem) {
                elem.show = function() {
                    const sp = this
                    sp.visible = true
                }
                elem.hide = function() {
                    const sp = this
                    sp.visible = false
                }
            }

            const ANIM_DURATION = 1000

            const addMoveShowHide = function(elem, offset, delay) {
                const POS = {
                        show: {x: elem.x, y: elem.y},
                        hide: {x: elem.x + offset.x, y: elem.y + offset.y},
                    }
                const EASING = TweenManager.Easing.Quadratic.Out
                elem.show = function() {                    
                    const sp = this
                    sp.visible = true
                    const coords = {x: sp.x, y: sp.y} 
                    const tween = new TweenManager.Tween(coords)
                        .to(POS.show , ANIM_DURATION)
                        .easing(EASING)
                        .onUpdate(() => {
                            sp.x = coords.x
                            sp.y = coords.y
                        })
                        .delay(delay)
                        .start()
                }
                elem.hide = function() {
                    const sp = this
                    sp.visible = false
                    sp.x = POS.hide.x
                    sp.y = POS.hide.y
                }                
            }

            const addScaleShowHide = function(elem, delay) {
                const EASING = TweenManager.Easing.Quadratic.Out
                elem.show = function() {                    
                    const sp = this
                    sp.visible = true
                    
                    const coords = {x: sp.scale.x, y: sp.scale.y}
                    const tweenA = new TweenManager.Tween(coords)
                        .to( {x: 1.2, y: 1.2} , 0.5 * ANIM_DURATION)
                        .easing(EASING)
                        .onUpdate(() => {
                            sp.scale.set(coords.x)
                        })
                        .delay(delay)
                    const tweenB = new TweenManager.Tween(coords)
                        .to( {x: 0.8, y: 0.8} , 0.25 * ANIM_DURATION)
                        .easing(EASING)
                        .onUpdate(() => {
                            sp.scale.set(coords.x)
                        })
                    const tweenC = new TweenManager.Tween(coords)
                        .to( {x: 1, y: 1} , 0.25 * ANIM_DURATION)
                        .easing(EASING)
                        .onUpdate(() => {
                            sp.scale.set(coords.x)
                        })

                    tweenA.chain(tweenB)
                    tweenB.chain(tweenC)
                    tweenA.start()
                }
                elem.hide = function() {
                    const sp = this
                    sp.visible = false
                    sp.scale.set(0)
                }                
            }

            const addAlphaShowHide = function(elem, delay) {
                const EASING = TweenManager.Easing.Quadratic.Out
                elem.show = function() {                    
                    const sp = this
                    sp.visible = true
                    
                    const coords = {x: sp.alpha, y: sp.alpha}
                    const tween = new TweenManager.Tween(coords)
                        .to( {x: 1, y: 1} , 1000)
                        .easing(EASING)
                        .onUpdate(() => {
                            sp.alpha = coords.x
                        })
                        .delay(delay)
                        .start()
                }
                elem.hide = function() {
                    const sp = this
                    sp.visible = false
                    sp.alpha = 0
                }                
            }

            const res = function(portrait, landscape) {
                if( landscape == null)
                    landscape = portrait

                return self.checkOrientation() == "PORTRAIT" ? portrait : landscape
            }

            const flip = function(elem) {
                elem.scale.set( 
                    self.checkOrientation() == "PORTRAIT" ? elem.scale.x : -elem.scale.x,                    
                    elem.scale.y,
                )
            }

            const orientationSuffix = self.checkOrientation() == "LANDSCAPE" ? "LandScape" :  "Portrait"
            
            //------ P1 ------//
            {
                const elem = addSprite('imgP1Bowl', res(0.5, 0.668), res(0.69 + 0.025, 0.783), 1)
                addMoveShowHide(
                    elem,
                    {
                        x: 0,
                        y: self.height
                    },
                    1000,
                )                
                self.gameState.addChild('p1', elem)
                self.gameState.addChild('p2', elem)                
            }            
            {
                const elem = addSprite('imgP1Salad', res(0.8, 0.221), res(0.38 + 0.025, 0.676), 1)
                addScaleShowHide(elem, 500)
                self.gameState.addChild('p1', elem)
                self.gameState.addChild('p2', elem)               
            }
            {
                const elem = addSprite('imgP1Water', res(0.872, 0.106), res(0.53 + 0.025, 0.894), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p1', elem)
                self.gameState.addChild('p2', elem)
            }
            {
                const elem = addSprite('imgP1Star', res(0.189, 0.915), res(0.401 + 0.025, 0.407), 1)
                addScaleShowHide(elem, 250)  
                self.gameState.addChild('p1', elem)
                self.gameState.addChild('p2', elem)            
            }
            {
                const elem = addSprite('imgP1Title', res(0.5, 0.410), res(0.189 + 0.025, 0.242), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p1', elem)
            }
            {
                const elem = addSprite('imgP1Start', res(0.478, 0.820), res(0.394, 0.380), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p1', elem)
                elem.buttonMode = true
                elem.interactive = true
                elem.on('pointerdown', function ()
                {
                    if( self.gameState.getCurrPage() == 'p1' )
                        self.gameState.setPage('p2')
                })
            }
            {
                const elem = addSprite('imgP1Logo', res(0.5, 0.226), res(0.95, 0.9), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p1', elem)
            }
            //------ P2 ------//
            {
                const elem = addSprite('imgP2Question', res(0.476, 0.302) , res(0.114, 0.148), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p2', elem)
            }
            {
                const elem = addSprite('imgP2Choice1', res(0.337, 0.294), res(0.239, 0.308), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p2', elem)
                makeAnswer(elem, 'p2', 0)
            }
            {
                const elem = addSprite('imgP2Choice2', res(0.719, 0.576), res(0.238, 0.306), 1)
                addScaleShowHide(elem, 500)
                self.gameState.addChild('p2', elem)
                makeAnswer(elem, 'p2', 1)
            }            
            
            //------ P3 ------//
            {
                const elem = addSprite('imgP3Calendar', res(0.488, .351), res(0.304, .515), 1)
                addMoveShowHide(
                    elem,
                    {
                        x: 0,
                        y: -self.height
                    },
                    0,
                )
                self.gameState.addChild('p3', elem)
            }
            {
                const elem = addSprite('imgP3Choice1', res(0.253, .717),res(0.828, .188), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p3', elem)
                makeAnswer(elem, 'p3', 0)
            }
            {
                const elem = addSprite('imgP3Choice2', res(0.691, .697), res(0.828, .364), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p3', elem)
                makeAnswer(elem, 'p3', 1)
            }
            {
                const elem = addSprite('imgP3Choice3', res(0.345, .696), res(0.910, .536), 1)
                addAlphaShowHide(elem, 1600)
                self.gameState.addChild('p3', elem)
                makeAnswer(elem, 'p3', 2)
            }
            {
                const elem = addSprite('imgP3Choice4', res(0.763, .776), res(0.910, .688), 1)
                addAlphaShowHide(elem, 1800)
                self.gameState.addChild('p3', elem)
                makeAnswer(elem, 'p3', 3)
            }
            {
                const elem = addSprite('imgP3Pen', res(0.441, .360), res(0.616, .893), 1)
                addScaleShowHide(elem, 1000)
                self.gameState.addChild('p3', elem)
            }
            {
                const elem = addSprite('imgP3PostIt', res(0.891, .918), res(0.127, .278), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p3', elem)
            }
            {
                const elem = addSprite('imgP3Question', res(0.519, .469), res(0.743, .061), 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p3', elem)
            }
            {
                const elem = addSprite('imgP3Star1', res(0.166), res(0.677), 1)
                addScaleShowHide(elem, 500)
                self.gameState.addChild('p3', elem)
            }
            {
                const elem = addSprite('imgP3Star2', res(0.5, .652), res(0.625, .864), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p3', elem)
            }

            //------ P4 ------//
            {
                const elem = addSprite('imgP4Choice1', res(0.280, .195), res(0.195, .321), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p4', elem)
                makeAnswer(elem, 'p4', 0)
            }
            {
                const elem = addSprite('imgP4Choice2', res(0.714, .200), res(0.198, .508), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p4', elem)
                makeAnswer(elem, 'p4', 1)
            }
            {
                const elem = addSprite('imgP4Choice3', res(0.276, .204), res(0.276, .689), 1)
                addAlphaShowHide(elem, 1600)
                self.gameState.addChild('p4', elem)
                makeAnswer(elem, 'p4', 2)
            }
            {
                const elem = addSprite('imgP4Choice4', res(0.715, .213), res(0.277, .867), 1)
                addAlphaShowHide(elem, 1800)
                self.gameState.addChild('p4', elem)
                makeAnswer(elem, 'p4', 3)
            }            
            {
                const elem = addSprite('imgP4Question', res(0.445, .300), res(0.094, .105), 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p4', elem)
            }
            {
                const elem = addSprite('imgP4Spoon', res(0.397, .560), res(0.697, .650), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p4', elem)
            }
            {
                const elem = addSprite('imgP4Veg', res(0.612, .706), res(0.590, .419), 1)
                addScaleShowHide(elem, 500)
                self.gameState.addChild('p4', elem)
            }

            //------ P5 ------//
            {
                const elem = addSprite('imgP5Garnish2', res(0.182, .353), res(0.618, .528), 1)
                addScaleShowHide(elem, 1400)
                flip(elem)
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Paper', res(0.506, .720), res(0.555, .496), 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Question', res(0.530, .309), res(0.106, .496), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p5', elem)                
            }
            {
                const elem = addSprite('imgP5Multiple', res(0.323, .155), res(0.170, .576), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p5', elem)     
            }
            {
                const elem = addSprite('imgP5Choices', res(0.545, .735), res(0.547, .474), 1)
                addAlphaShowHide(elem, 1600)
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Bullets', res(0.337, .590), res(0.550, .480), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p5', elem)
                makeAnswer(elem, 'p5', 0)
            }
            {
                const elem = addSprite('imgP5Carrot', res(0.157, .120), res(0.400, .251), 1)
                addMoveShowHide(
                    elem,
                    {
                        x: -self.width,
                        y: 0,
                    },
                    250,
                )
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Broccoli', res(0.140, .106), res(0.766, .781), 1)
                addMoveShowHide(
                    elem,
                    {
                        x: -self.width,
                        y: 0,
                    },
                    500,
                )
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Tomato', res(0.762, .448), res(0.917, .887), 1)
                addMoveShowHide(
                    elem,
                    {
                        x: self.width,
                        y: 0,
                    },
                    1000,
                )
                flip(elem)
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Leafy', res(0.810, .895), res(0.574, .517), 1)
                addMoveShowHide(
                    elem,
                    {
                        x: self.width,
                        y: 0,
                    },
                    750,
                )
                self.gameState.addChild('p5', elem)
            }
            {
                const elem = addSprite('imgP5Garnish1', res(0.911, .930), res(0.519, .485), 1)
                addScaleShowHide(elem, 1200)
                self.gameState.addChild('p5', elem)
            }
            {
                self.checkmarks = []
                let pos = [
                    {
                        x: res(.336, .588), y: res(.284, .127),
                    },
                    {
                        x: res(.336, .588), y: res(.399, .279),
                    },
                    {
                        x: res(.336, .588), y: res(.511, .428),
                    },
                    {
                        x: res(.336, .588), y: res(.622, .576),
                    },
                    {
                        x: res(.336, .588), y: res(.724, .711),
                    },
                    {
                        x: res(.336, .588), y: res(.814, .832),
                    },
                ]

                for(let i = 0; i < 6; ++i)
                {
                    const elem = addSprite('imgP5Check', pos[i].x, pos[i].y, 1)
                    addDefaultShowHide(elem)
                    self.checkmarks.push(elem)
                    self.gameState.addChild('p5', elem)
                }
            }
            {
                const elem = addSprite('imgP5Next', res(0.635, .830), res(0.783, .834), 1)
                addAlphaShowHide(elem, 1000)
                makeAnswer(elem, 'p5', "NEXT")
                self.gameState.addChild('p5', elem)
            }
            //------ P6 ------//
            {
                const elem = addSprite('imgP6Question', res(0.383, .275), res(0.057, .127), 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p6', elem)
            }
            {
                const elem = addSprite('imgP6Banana', res(0.108, .038), res(0.596, 0.622), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p6', elem)
            }
            {
                const elem = addSprite('imgP6Plate', res(0.500, .659), res(0.564, .548), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p6', elem)
            }
            {
                const elem = addSprite('imgP6Choice1', res(0.171, .130), res(0.132, .270), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p6', elem)
                makeAnswer(elem, 'p6', 1)
            }
            {
                const elem = addSprite('imgP6Choice2', res(0.450, .329), res(0.131, .269), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p6', elem)
                makeAnswer(elem, 'p6', 0)
            }            
            {
                const elem = addSprite('imgP6Garnish', res(0.227, .973), res(0.364, .584), 1)
                addScaleShowHide(elem, 750)
                self.gameState.addChild('p6', elem)
            }
            {
                const elem = addSprite('imgP6Watermelon', res(0.855, .212), res(0.544, .752), 1)
                addScaleShowHide(elem, 1000)
                self.gameState.addChild('p6', elem)
            }

            //------ P7 ------//
            {
                const elem = addSprite('imgP7Agenda', res(0.478, .308), res(0.596, .566), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p7', elem)
            }
            {
                const elem = addSprite('imgP7Question', res(0.510, .656), res(0.067, .093), 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p7', elem)
            }            
            {
                const elem = addSprite('imgP7Pen', res(0.498, .327), res(0.492, .529), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p7', elem)
            }
            {
                const elem = addSprite('imgP7Choice1', res(0.256, .813), res(0.140, .263), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p7', elem)
                makeAnswer(elem, 'p7', 0)
            }
            {
                const elem = addSprite('imgP7Choice2', res(0.642, .867), res(0.139, .400), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p7', elem)
                makeAnswer(elem, 'p7', 1)
            }
            {
                const elem = addSprite('imgP7Choice3', res(0.287, .784), res(0.208, .531), 1)
                addAlphaShowHide(elem, 1600)
                self.gameState.addChild('p7', elem)
                makeAnswer(elem, 'p7', 2)
            }
            {
                const elem = addSprite('imgP7Choice4', res(0.618, .892), res(0.207, .641), 1)
                addAlphaShowHide(elem, 1800)
                self.gameState.addChild('p7', elem)
                makeAnswer(elem, 'p7', 3)
            }

            //------ P8 ------//
            {
                const elem = addSprite('imgP8Banana', res(0.880, .916), res(0.857, .782), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8BGPortrait', 0.525, 0.558, 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8Question', 0.441, 0.505, 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8Choice1', res(0.267, .307), res(0.590, .609), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p8', elem)
                makeAnswer(elem, 'p8', 0)
            }
            {
                const elem = addSprite('imgP8Choice2', res(0.746, .680), res(0.594, .605), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p8', elem)
                makeAnswer(elem, 'p8', 1)
            }
            {
                const elem = addSprite('imgP8Choice3', res(0.334, .358), res(0.677, .720), 1)
                addAlphaShowHide(elem, 1600)
                self.gameState.addChild('p8', elem)
                makeAnswer(elem, 'p8', 2)
            }
            {
                const elem = addSprite('imgP8Choice4', res(0.764, .684), res(0.675, .722), 1)
                addAlphaShowHide(elem, 1800)
                self.gameState.addChild('p8', elem)
                makeAnswer(elem, 'p8', 3)
            }            
            {
                const elem = addSprite('imgP8Mango', res(0.136, .106), res(0.715, .661), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p8', elem)               
            }
            {
                const elem = addSprite('imgP8Orange', res(0.705, .813), res(0.225, .282), 1)
                addScaleShowHide(elem, 500)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8Grape', res(0.173, .131), res(0.194, .227), 1)
                addScaleShowHide(elem, 500)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8Rambutan', res(0.428, .568), res(0.926, .899), 1)
                addScaleShowHide(elem, 750)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8List1', 0.299, 0.175, 1)
                addAlphaShowHide(elem, 2000)
                self.gameState.addChild('p8', elem)
            }
            {
                const elem = addSprite('imgP8List2', 0.435, 0.315, 1)
                addAlphaShowHide(elem, 2200)
                self.gameState.addChild('p8', elem)
            }

            //------ P9 ------//
            {
                const elem = addSprite('imgP9Fruits', res(0.500, .637), res(0.555, .601), 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p9', elem)
            }
            {
                const elem = addSprite('imgP9Question', res(0.279, .265), res(0.089, .140), 1)
                addAlphaShowHide(elem, 1000)
                self.gameState.addChild('p9', elem)
            }
            {
                const elem = addSprite('imgP9Choice1', res(0.265, .447), res(0.410, .435), 1)
                addAlphaShowHide(elem, 1200)
                self.gameState.addChild('p9', elem)
                makeAnswer(elem, 'p9', 0, true)
            }
            {
                const elem = addSprite('imgP9Choice2', res(0.725, .816), res(0.408, .427), 1)
                addAlphaShowHide(elem, 1400)
                self.gameState.addChild('p9', elem)
                makeAnswer(elem, 'p9', 1, true)
            }
            {
                const elem = addSprite('imgP9Choice3', res(0.286, .453), res(0.484, .538), 1)
                addAlphaShowHide(elem, 1600)
                self.gameState.addChild('p9', elem)
                makeAnswer(elem, 'p9', 2, true)
            }
            {
                const elem = addSprite('imgP9Choice4', res(0.723, .818), res(0.485, .538), 1)
                addAlphaShowHide(elem, 1800)
                self.gameState.addChild('p9', elem)
                makeAnswer(elem, 'p9', 3, true)
            }
            {
                const elem = addSprite('imgP9Garnish', res(0.202, .136), res(0.220, .266), 1)
                addScaleShowHide(elem, 250)
                self.gameState.addChild('p9', elem)
            }

            //DEBUG DRAGGIN
            // _
            //     .chain(self.gameState._pages[ DEBUG_CONST.startPage ])
            //     .forEach((elem) => {
            //         makeDragable( elem )
            //     })
            //     .value()

            //------ P10 11 12 13 ------//
            {
                const elem = addSprite('imgP10FramePortrait', 0.5, 0.5, 1)
                if( self.checkOrientation() == "LANDSCAPE" )
                    elem.rotation = Math.PI * 0.5
                
                addAlphaShowHide(elem, 0)
                self.gameState.addChild('p10', elem)
                self.gameState.addChild('p11', elem)
                self.gameState.addChild('p12', elem)
                self.gameState.addChild('p13', elem)
            }
            //------ P10 ------//
                       
            {
                const elem = addSprite('imgP10Result1' + orientationSuffix, 0.5, 0.5, 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p10', elem)
            }
            //------ P11 ------//            
            {
                const elem = addSprite('imgP10Result2' + orientationSuffix, 0.5, 0.5, 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p11', elem)
            }
            //------ P12 ------//            
            {
                const elem = addSprite('imgP10Result3' + orientationSuffix, 0.5, 0.5, 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p12', elem)
            }
            //------ P13 ------//            
            {
                const elem = addSprite('imgP10Result4' + orientationSuffix, 0.5, 0.5, 1)
                addScaleShowHide(elem, 0)
                self.gameState.addChild('p13', elem)
            }
            //------ P10 11 12 13 ------//
            {
                const elem = addSprite('imgP10Replay', res(0.5, 0.763), res(0.9, 0.311), 1)
                
                addAlphaShowHide(elem, 500)
                self.gameState.addChild('p10', elem)
                self.gameState.addChild('p11', elem)
                self.gameState.addChild('p12', elem)
                self.gameState.addChild('p13', elem)

                elem.buttonMode = true
                elem.interactive = true
                elem.on('pointerdown', function ()
                {
                    EventBus.$emit("RESTART_QUIZ")
                })
            }
            
            self.gameState.hideAllPages()
            self.gameState.setPage( 
                (DEBUG_CONST.enableDebug ? DEBUG_CONST.startPage : "p1")
            )
        })

        app.ticker.add(function(delta) {
            self.gameLoop(delta)            
            TweenManager.update()
        })
    },    
    methods: {
        // ...mapActions({
        //     readItemAsync: types.READ_ITEM_ASYNC,
        // }),
        // ...mapMutations({
        //     setItem: types.SET_ITEM,
        // }),
        forceRerender() {
            this.reRenderKey += 1;  
        },
        registerBGM( srcPathWithRequire ) {
            const self = this
            const app = self.app

            window.addEventListener('click', function (e) {
                if( !self.audioPlayed ) {
                    var audio = new Audio( srcPathWithRequire )
                    audio.play()
                    audio.loop = true
                    self.audioPlayed = true
                }
            })
        },
        gameLoop(delta) {
            const self = this

            self.iter += 1 
        },
        resize() {
            const self = this

            let w = window.innerWidth
            let h = window.innerHeight

            //Calculate Ratio
            if( h > w ) {
                self.width = CONFIG_CONST.shortDim
                self.height = CONFIG_CONST.longDim
            } else {
                self.width = CONFIG_CONST.longDim
                self.height = CONFIG_CONST.shortDim
            }

            self.ratio = self.width / self.height
            self.renderer.view.width = self.width
            self.renderer.view.height = self.height
            //

            if (window.innerWidth / window.innerHeight >= self.ratio) {
                w = window.innerHeight * self.ratio
                h = window.innerHeight
            } else {
                w = window.innerWidth
                h = window.innerWidth / self.ratio
            }

            self.renderer.view.style.width = Util.intPXToCssStr(w)
            self.renderer.view.style.height = Util.intPXToCssStr(h)

            //Center PIXI canvas
            self.renderer.view.style.position = 'absolute'
            self.renderer.view.style.left = ((window.innerWidth - w) * 0.5) + 'px'
        },
        checkOrientation() {
            return this.ratio < 1 ? "PORTRAIT" : "LANDSCAPE" 
        },
    },
    computed: {
        // ...mapGetters({
        //     getITEM: types.GET_ITEM,
        // }),
        // someComputed: function () {
        //     return someValue;
        // },
    },
    components: {    
        // SomeComponent,
    },
}
</script>

<style scoped>
</style>